import React, { useEffect, useState } from 'react';
import { Box, Paper, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { getAllMangerAppraisalCycleLists } from '../../../redux/features/appraisalSlice';
import GlobalDatagrid from '../../../components/mui/DataGrid/GlobalDatagrid';
import { managerAppraisalCycleList } from '../../../components/datagrid/appraisal/managerAppraisalCycleList';
import ManagerUserListingLanding from './addEvaluationSelf/ManagerUserListingLanding';

export const ManagerAppraisalLanding = () => {
  const [showAlternateView, setShowAlternateView] = useState(false);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search } = paginationData;
  const { loading, apprasialCycleListsForManagers } = useSelector((state) => state.appraisal);
  const [selectedCycleId, setSelectedCycleId] = useState(null);
  const [cycleName,setCycleName]=useState(null)

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const dispatchParams = { paginationData, search };

  useEffect(() => {
    if (pageNum && gridSize && !showAlternateView) {
      dispatch(getAllMangerAppraisalCycleLists(dispatchParams));
    }
  }, [gridSize, pageNum, search, showAlternateView]);

  const goToSecondView = (cycleId,cycleName) => {
    setShowAlternateView(true);
    setSelectedCycleId(cycleId);
    setCycleName(cycleName)
  };
  const goBack = () => {
    setShowAlternateView(false);
    setSelectedCycleId(null);
    setCycleName(null)
  };
  return (
    <Box mt={0.5}>
      {!showAlternateView ? (
        <Paper>
          <GlobalDatagrid
            tableHead={managerAppraisalCycleList(goToSecondView)}
            rows={apprasialCycleListsForManagers?.data}
            meta={apprasialCycleListsForManagers?.meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={false}
          />
        </Paper>
      ) : (
        <Box>
          <ManagerUserListingLanding goBack={goBack} selectedCycleId={selectedCycleId} cycleName={cycleName} />
        </Box>
      )}
    </Box>
  );
};
